import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Snippet from "../snippet.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <blockquote>
      <p parentName="blockquote">{`This is the simplest way to get PostHog up and running on your website, and only takes a few minutes to set-up.`}</p>
    </blockquote>
    <h4 {...{
      "id": "add-to-your-website--app"
    }}>{`Add to your website `}{`&`}{` app`}</h4>
    <p>{`Paste this snippet within the `}<inlineCode parentName="p">{`<head>`}</inlineCode>{` tags of your website - ideally just inside the closing `}<inlineCode parentName="p">{`</head>`}</inlineCode>{` tag - on all pages that you wish to track.`}</p>
    <Snippet mdxType="Snippet" />
    <p>{`Be sure to replace `}<inlineCode parentName="p">{`<ph_project_api_key>`}</inlineCode>{` and `}<inlineCode parentName="p">{`<ph_instance_address>`}</inlineCode>{` with your project's values. (You can find the snippet pre-filled with this data in the PostHog app under Project / Settings. `}<em parentName="p">{`(Quick links if you use `}<a parentName="em" {...{
          "href": "https://app.posthog.com/project/settings"
        }}>{`PostHog Cloud US`}</a>{` or `}<a parentName="em" {...{
          "href": "https://eu.posthog.com/project/settings"
        }}>{`PostHog Cloud EU`}</a>{`)`}</em></p>
    <h4 {...{
      "id": "what-this-code-does"
    }}>{`What this code does`}</h4>
    <p>{`After adding the snippet to your website, it will automatically start to:`}</p>
    <ul>
      <li parentName="ul">{`Capture `}<inlineCode parentName="li">{`$pageview`}</inlineCode>{` events when a user visits a page`}</li>
      <li parentName="ul">{`Track when users `}<a parentName="li" {...{
          "href": "/docs/data/autocapture"
        }}>{`click on links or buttons`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/docs/user-guides/recordings"
        }}>{`Record videos of user sessions`}</a>{` that you can play back (if you've enabled the Session recordings feature, which we highly recommend!)`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      